'use client'

import type { ComponentProps } from 'react'

import { useActionFlowDialog } from './ActionFlowDialog'
import { ActionFlowWidget } from './ActionFlowWidget'

type ActionFlowDialogWidgetProps = Omit<ComponentProps<typeof ActionFlowWidget>, 'onClose'> & {
  /** Runs once the dialog content has detached, after the dialog's own `onExit`. */
  onExit?: () => void
}

/**
 * `ActionFlowWidget` for use inside `ActionFlowDialog`. Done and Try again close the dialog through
 * `exit`, like its close button, so the dialog's `onExit` and then this `onExit` run only once the
 * content has detached.
 */
export function ActionFlowDialogWidget({ onExit, ...props }: ActionFlowDialogWidgetProps) {
  const { exit } = useActionFlowDialog()
  return <ActionFlowWidget {...props} onClose={() => exit(onExit)} />
}
